import { getStyle } from './getStyle';
import { Image, Text, View } from '@react-pdf/renderer';
import * as React from 'react';

const deckblatt = require('../../../../img/Deckblatt_THG_Bericht.jpg');
const deckblatt_back = require('../../../../img/Deckblatt_2023_back.jpg');

export function getDeckblatt(logoURL: string, unternehmen: string, jahr: number): JSX.Element {
    return (
        <View>
            <Image src={deckblatt} />
            <View style={getStyle('deckblattTitleJahr')}>
                <Text>&nbsp;</Text>
                <Text style={getStyle('deckblattTitleJahrNum')}>
                    {jahr}
                </Text>
            </View>
            <View style={getStyle('deckblattTitle')}>
                <Text>&nbsp;</Text>
                <Text style={getStyle('deckblattTitleFirmenname')}>
                    {unternehmen}
                </Text>
            </View>
            {logoURL && <Image src={logoURL} style={getStyle('deckblattLogo')} />}
        </View>
    );
}

export function getDeckblattBack(getPageNumber?: (pageNumber: number) => void): JSX.Element {
    return (
        <View>
            <Image src={deckblatt_back} />
            <Text
                render={({ pageNumber }) => {
                    if (typeof getPageNumber === 'function') {
                        getPageNumber(pageNumber);
                    }
                    return null;
                }}></Text>
        </View>
    );
}
